import dayjs from "dayjs";

import { formatIdentifier } from "@/utils/formatIdentifier";
import { phoneFormat } from "@/utils/formatPhone";
import { addressConcat } from "@/utils/adreessConcat";
import { getAge } from "@/utils/dateUtil";
import { DetailedCitizenAttendancesIndicatorB2 } from "@/services/esus/indicator/esb/b2/getDetailedCitizenAttendancesIndicatorB2";

import { TimeLine, TimeLineContent } from "@/components/TimeLine";
import { IndicatorEsbB2CitizenHistoryItem } from "./IndicatorEsbB2CitizenHistoryItem";
import { IndicatorEsbB2CitizenHistoryInfo } from "./IndicatorEsbB2CitizenHistoryInfo";

type IndicatorEsbB2CitizenHistoryProps = {
	citizenWithDentalAttendances: DetailedCitizenAttendancesIndicatorB2;
};

export function IndicatorEsbB2CitizenHistory({
	citizenWithDentalAttendances,
}: Readonly<IndicatorEsbB2CitizenHistoryProps>) {
	const indicatorEsbB2CitizenHistoryInfo = {
		fullName: citizenWithDentalAttendances.fullName
			? citizenWithDentalAttendances.fullName
			: "N/A",
		birthdate: citizenWithDentalAttendances.birthdate
			? dayjs(citizenWithDentalAttendances.birthdate).format("DD/MM/YYYY")
			: "N/A",
		age: citizenWithDentalAttendances.birthdate
			? getAge(dayjs(citizenWithDentalAttendances.birthdate))
			: "",
		document: citizenWithDentalAttendances.cpf
			? formatIdentifier(citizenWithDentalAttendances.cpf)
			: citizenWithDentalAttendances.cns ?? "",
		motherName: citizenWithDentalAttendances.motherName ?? "",
		phone: citizenWithDentalAttendances.phone
			? phoneFormat(citizenWithDentalAttendances.phone)
			: "",
		address:
			addressConcat(
				citizenWithDentalAttendances.street,
				citizenWithDentalAttendances.houseNumber,
				citizenWithDentalAttendances.neighborhood
			) ?? "",
	};

	return (
		<>
			<IndicatorEsbB2CitizenHistoryInfo {...indicatorEsbB2CitizenHistoryInfo} />
			<TimeLine
				timeLineTitle="Atendimentos Odontológicos"
				timeLineContents={(
					citizenWithDentalAttendances.dentalAttendances ?? []
				).map<TimeLineContent>((dentalAttendance) => {
					return {
						content: (
							<IndicatorEsbB2CitizenHistoryItem dentalAttendance={dentalAttendance} />
						),
						eventDate: dentalAttendance.date
							? dayjs(dentalAttendance.date).format("DD/MM/YYYY")
							: "N/A",
					};
				})}
			/>
		</>
	);
}
